import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { auth } from './config/firebase';

const container = document.getElementById('root') as HTMLElement;
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);

let hasRendered = false;
auth.onAuthStateChanged(() => {
  if (!hasRendered) {
    hasRendered = true;
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }
});
